import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'
import HomeStore from './HomeStore'
import SurveyStore from '../Survey/SurveyStore'
import DataTable from '../DataTable'
import ChooseIndustryModal from '../Modals/ChooseIndustryModal'
import Button from '../../UniformComponents/Button'
import LinkButton from '../../UniformComponents/LinkButton'
import Anchor from '../../UniformComponents/Anchor'
import Badge from '../../UniformComponents/Badge'
import Tooltip from '../../UniformComponents/Tooltip'
import Panel from '../../UniformComponents/Panel'
import { getUserLink } from '../../utils/helpers'
import Typography from '../../UniformComponents/Typography'

import icon from './icon.svg'

import './home.scss'

@observer
class Home extends Component {
    constructor(props) {
        super(props)
        const { store } = props
        this.homeStore = new HomeStore(store)
        this.maxbiStatus = store.getMaxbiStatus()
        this.surveyTabs = [{ key: 'PE', value: 'Explori Surveys' }, { key: 'EM', value: 'Maxbi Entries' }]
        this.state = {
            // clickedElement: '',
            activeTabKey: this.maxbiStatus.nonMaxbi ? 'PE' : 'EM',
        }
        this.setColumns()

        store.breadcrumps = []
    }

    componentDidMount() {
        this.homeStore.initSearch(this.maxbiStatus)
    }

    setColumns = () => {
        const { store } = this.props
        this.surveyStore = new SurveyStore(store)
        const { showNewDashboards } = store
        const { activeTabKey } = this.state

        this.activeSurveyColumns = [
            {
                name: i18n.t('breadcrumb_Product'),
                key: 'productName',
                dataTransform: (productName) => (
                    productName.replace(/&amp;/gi, '&')
                ),
            },
            {
                name: i18n.t('breadcrumb_Survey'),
                key: 'surveyName',
                cellClass: 'bold',
                dataTransform: (surveyName) => (
                    surveyName.replace(/&amp;/gi, '&')
                ),
            },
            {
                name: i18n.t('completed'),
                key: 'completed',
                headerClass: 'center',
                dataTransform: (completed) => (
                    <Badge
                        type="success"
                        cssClass="rounded center"
                        label={completed}
                    />
                ),
            },
            {
                name: i18n.t('dropped'),
                key: 'dropped',
                headerClass: 'center',
                dataTransform: (dropped) => (
                    <Badge
                        type="warning"
                        cssClass="rounded center"
                        label={dropped}
                    />
                ),
            },
            {
                name: i18n.t('report_screen'),
                key: 'screened',
                headerClass: 'center',
                dataTransform: (screened) => (
                    <Badge
                        type="error"
                        cssClass="rounded center"
                        label={screened}
                    />
                ),
            },
            {
                name: '',
                key: 'sIdpIdrType',
                cellClass: 'center',
                dataTransform: (sIdpIdrType, { productId }) => {
                    const surveyKeyVals = JSON.parse(sIdpIdrType)
                    return (
                        <div className="survey-btn-wrapper">
                            {
                                surveyKeyVals.surveyTypeName === 'Benchmarking'
                                && (
                                    <Anchor
                                        cssClass="icon-link-btn"
                                        onClick={(e) => e.stopPropagation()}
                                        href={store.getDashboardLink('product', productId)}
                                    >
                                        <Tooltip
                                            text={i18n.t('home.table.surveyBtn.productDash')}
                                            direction="bottom"
                                        />
                                        <i className="fa-light fa-gauge-simple-max" />
                                    </Anchor>
                                )
                            }
                            <Anchor
                                cssClass="icon-link-btn"
                                onClick={(e) => e.stopPropagation()}
                                href={`/survey/${surveyKeyVals.surveyId}/report`}
                            >
                                <Tooltip
                                    text={i18n.t('home.table.surveyBtn.viewReport')}
                                    direction="bottom"
                                />
                                <i className="fa-light fa-chart-column" />
                            </Anchor>
                            <Anchor
                                cssClass="icon-link-btn"
                                onClick={(e) => e.stopPropagation()}
                                href={`/survey/${surveyKeyVals.surveyId}/setup`}
                            >
                                <Tooltip
                                    text={i18n.t('home.table.surveyBtn.editSurvey')}
                                    direction="bottom"
                                />
                                <i className="fa-light fa-edit" />
                            </Anchor>
                        </div>
                    )
                },
            },
        ]

        this.developmentSurveyColumns = [
            {
                name: i18n.t('breadcrumb_Product'),
                key: 'productName',
                dataTransform: (productName) => (
                    productName.replace(/&amp;/gi, '&')
                ),
            },
            {
                name: i18n.t('breadcrumb_Survey'),
                key: 'surveyName',
                cellClass: 'bold',
                dataTransform: (surveyName) => (
                    surveyName.replace(/&amp;/gi, '&')
                ),
            },
            {
                name: i18n.t('survey_type'),
                key: 'surveyType',
            },
            {
                name: '',
                key: 'sIdpIdrType',
                cellClass: 'center',
                dataTransform: (sIdpIdrType) => {
                    const surveyKeyVals = JSON.parse(sIdpIdrType)
                    return (
                        <div className="survey-btn-wrapper">
                            <Anchor
                                cssClass="icon-link-btn"
                                onClick={(e) => e.stopPropagation()}
                                href={`/survey/${surveyKeyVals.surveyId}/setup`}
                            >
                                <Tooltip
                                    text={i18n.t('home.table.surveyBtn.editSurvey')}
                                    direction="bottom"
                                />
                                <i className="fa-light fa-edit" />
                            </Anchor>
                        </div>
                    )
                },
            },
        ]

        this.reportUserColumns = [
            {
                name: i18n.t('breadcrumb_Product'),
                key: 'productName',
                cellClass: 'bold',
            },
            {
                name: i18n.t('breadcrumb_Survey'),
                key: 'surveyName',
            },
            {
                name: i18n.t('completed'),
                key: 'completed',
                dataTransform: (completed) => (
                    <Badge
                        type="success"
                        cssClass="rounded"
                        label={completed}
                        icon="fa-regular fa-check"
                    />
                ),
            },
            {
                name: i18n.t('dropped'),
                key: 'dropped',
                dataTransform: (dropped) => (
                    <Badge
                        type="warning"
                        cssClass="rounded"
                        label={dropped}
                        icon="fa-regular fa-arrow-down"
                    />
                ),
            },
            {
                name: i18n.t('report_screen'),
                key: 'screened',
                dataTransform: (screened) => (
                    <Badge
                        type="error"
                        cssClass="rounded"
                        label={screened}
                        icon="fa-regular fa-ban"
                    />
                ),
            },
            {
                name: '',
                key: 'sIdpIdrType',
                cellClass: 'center',
                dataTransform: (sIdpIdrType, { productId }) => {
                    const surveyKeyVals = JSON.parse(sIdpIdrType)
                    return (
                        <div className="survey-btn-wrapper">
                            {
                                surveyKeyVals.surveyTypeName === 'Benchmarking'
                                && (
                                    <Anchor
                                        cssClass="icon-link-btn"
                                        onClick={(e) => e.stopPropagation()}
                                        href={store.getDashboardLink('product', productId)}
                                    >
                                        <Tooltip
                                            text={i18n.t('home.table.surveyBtn.productDash')}
                                            direction="bottom"
                                        />
                                        <i className="fa-regular fa-gauge-simple-max" />
                                    </Anchor>
                                )
                            }
                            <Anchor
                                href={`/survey/${surveyKeyVals.surveyId}/report`}
                                cssClass="icon-link-btn"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Tooltip
                                    text={i18n.t('home.table.surveyBtn.viewReport')}
                                    direction="bottom"
                                />
                                <i className="fa-light fa-chart-column" />
                            </Anchor>
                        </div>
                    )
                },
            },
        ]

        this.maxbiEntryColumns = [
            {
                name: i18n.t('breadcrumb_Product'),
                key: 'productName',
                cellClass: 'bold',
            },
            {
                name: 'Status',
                key: 'status',
                dataTransform: (status) => {
                    switch (status) {
                        case 'completed': return (
                            <Badge
                                type="success"
                                label={i18n.t('maxbiSearch.status_1')}
                                icon="fa-regular fa-circle-check"
                            />
                        )
                        case 'inprogress': return (
                            <Badge
                                type="warning"
                                label={i18n.t('maxbiSearch.status_2')}
                                icon="fa-regular fa-circle-half-stroke"
                            />
                        )
                        case 'incomplete': return (
                            <Badge
                                type="error"
                                label={i18n.t('maxbiSearch.status_3')}
                                icon="fa-regular fa-ban"
                            />
                        )
                        default: return null
                    }
                },
            },
            {
                name: 'Required action',
                key: 'status',
                cellClass: 'bold',
                dataTransform: (status, { publicId, surveyUserId }) => {
                    switch (status) {
                        case 'inprogress': return (
                            <LinkButton
                                isExternal
                                target="_blank"
                                cssClass={`action-btn ${status}`}
                                label={i18n.t('maxbiSearch.complete')}
                                href={getUserLink(publicId, surveyUserId, true)}
                                onClick={(e) => {
                                    e.stopPropagation()
                                }}
                            >
                                <i className="fa-sharp fa-regular fa-arrow-right" />
                            </LinkButton>
                        )
                        case 'incomplete': return (
                            <LinkButton
                                isExternal
                                target="_blank"
                                cssClass={`action-btn ${status}`}
                                label={i18n.t('maxbiSearch.complete')}
                                href={getUserLink(publicId, surveyUserId, true)}
                                onClick={(e) => {
                                    e.stopPropagation()
                                }}
                            >
                                <i className="fa-sharp fa-regular fa-arrow-right" />
                            </LinkButton>
                        )
                        default: return null
                    }
                },
            },
            {
                name: 'Event dates',
                key: 'eventDates',
                cellClass: '',
                dataTransform: (eventDates, { startDate, closeDate }) => {
                    const sDate = new Date(startDate).toLocaleString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                    })
                    const cDate = new Date(closeDate).toLocaleString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                    })

                    return `${sDate} - ${cDate}`
                },
            },
            {
                name: '',
                key: 'surveyId',
                cellClass: 'center',
                dataTransform: (surveyId, { productId }) => (
                    <div className="survey-btn-wrapper">
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={(e) => e.stopPropagation()}
                            href={store.getDashboardLink('product', productId)}
                        >
                            <Tooltip
                                text={i18n.t('home.table.surveyBtn.productDash')}
                                direction="bottom"
                            />
                            <i className="fa-light fa-gauge-simple-max" />
                        </Anchor>
                        <Anchor
                            cssClass="icon-link-btn"
                            onClick={(e) => e.stopPropagation()}
                            href={`/survey/${surveyId}/report`}
                        >
                            <Tooltip
                                text={i18n.t('home.table.surveyBtn.viewReport')}
                                direction="bottom"
                            />
                            <i className="fa-light fa-chart-column" />
                        </Anchor>
                    </div>
                ),
            },
        ]
    }

    spinner = () => (
        <div className="spinner">
            <img src={`${process.env.CDN_URL}/includes/images/loading.svg`} alt="loader" />
        </div>
    )

    permissionCheck = (allowedRoles) => {
        const { store } = this.props
        const currentUserRole = store.tokenData.roles
        return allowedRoles.some((role) => currentUserRole.includes(role))
    }

    openBuilder(e, surveyId) {
        const { history } = this.props
        history.push(`/survey/${surveyId}/setup`)
        e.stopPropagation()
    }

    openReport(e, surveyId) {
        const { history } = this.props
        history.push(`/survey/${surveyId}/report`)
        e.stopPropagation()
    }

    renderEmptyMessage = (type) => (
        <div className="emptyMessageContainer" style={type === 'maxbiEntries' ? { height: '535px' } : {}}>
            <img style={{ width: '350px', marginBottom: '40px' }} src={`${process.env.CDN_URL}/images/homeNoSurveys.svg`} />
            <h3 style={{ marginBottom: '16px' }}>{i18n.t(`home.emptyMessage.title.${type}`)}</h3>
            <p>{i18n.t(`home.emptyMessage.subTitle.${type}`)}</p>
        </div>
    )

    renderDataTable = (type) => {
        const { history } = this.props
        const tableArgs = {
            active: {
                data: this.homeStore.activeSurveys || [],
                columns: this.activeSurveyColumns,
                rowClick: (e, surveyID) => { history.push(`survey/${surveyID}/report`) },
                rowId: 'surveyId',
                emptyMessage: this.renderEmptyMessage(type),
            },
            development: {
                data: this.homeStore.developmentSurveys || [],
                columns: this.developmentSurveyColumns,
                rowClick: (e, surveyID) => { history.push(`survey/${surveyID}/setup`) },
                rowId: 'surveyId',
                emptyMessage: this.renderEmptyMessage(type),
            },
            closed: {
                data: this.homeStore.closedSurveys || [],
                columns: this.activeSurveyColumns,
                rowClick: (e, surveyID) => { history.push(`survey/${surveyID}/setup`) },
                rowId: 'surveyId',
                emptyMessage: this.renderEmptyMessage(type),
            },
            reportUserSurveys: {
                data: this.homeStore.activeSurveys || [],
                columns: this.reportUserColumns,
                rowClick: (e, surveyID) => { history.push(`survey/${surveyID}/report`) },
                rowId: 'surveyId',
                emptyMessage: i18n.t('h_latest_activity_none'),
            },
            maxbiEntries: {
                data: this.homeStore.maxbiEntries || [],
                columns: this.maxbiEntryColumns,
                rowClick: (e, surveyId) => { history.push(`survey/${surveyId}/report`) },
                rowId: 'surveyId',
                emptyMessage: this.renderEmptyMessage(type),
            },
        }[type]

        if (tableArgs.data.length > 0) {
            return (
                <DataTable
                    store={this.homeStore}
                    dataSet={tableArgs.data}
                    columns={tableArgs.columns}
                    rowClick={tableArgs.rowClick}
                    rowId={tableArgs.rowId}
                />
            )
        }
        return <div className="no-surveys">{tableArgs.emptyMessage}</div>
    }

    renderTabs = () => {
        const { homeStore } = this
        const {
            surveys, selectedTab, changeTab,
        } = homeStore
        const { activeCount, developmentCount, closedCount } = surveys

        const activeSurveysCount = activeCount || 0
        const developmentSurveysCount = developmentCount || 0
        const closedSurveysCount = closedCount || 0

        return (
            <div className="tabs">
                <div
                    className={`tab ${selectedTab === 'active' ? 'selected' : ''}`}
                    onClick={() => changeTab('active')}
                >
                    <h3>Active</h3>
                    <span>
                        {activeSurveysCount}
                    </span>
                </div>
                {!this.permissionCheck(['150', '170']) ? (
                    <div
                        className={`tab ${selectedTab === 'development' ? 'selected' : ''}`}
                        onClick={() => changeTab('development')}
                    >
                        <h3>In Development</h3>
                        <span>
                            {developmentSurveysCount}
                        </span>
                    </div>
                ) : null}
                <div
                    className={`tab ${selectedTab === 'closed' ? 'selected' : ''}`}
                    onClick={() => changeTab('closed')}
                >
                    <h3>Closed</h3>
                    <span>
                        {closedSurveysCount}
                    </span>
                </div>
            </div>
        )
    }

    renderPanels = () => {
        const { activeTabKey } = this.state
        const { homeStore } = this
        const { selectedTab } = homeStore

        if (activeTabKey === 'EM') {
            return (
                <Panel>
                    <div className="header">
                        {i18n.t('home.panels.maxbi.maxbiEntries')}
                        {this.homeStore.maxbiEntries && this.homeStore.maxbiEntries.length > 0
                            && (
                                <LinkButton
                                    href="/maxbi/"
                                    style={{ boxShadow: 'none' }}
                                    cssClass="regular tertiary"
                                    label={i18n.t('home.panels.maxbi.viewAllEntries')}
                                />
                            )}
                    </div>
                    {this.homeStore.loadSpinner
                        ? this.spinner() : this.renderDataTable('maxbiEntries')}
                </Panel>
            )
        }

        return (
            <Fragment>
                <Panel>
                    <div className="header">
                        {this.renderTabs()}
                        <LinkButton
                            href="/survey/"
                            isExternal
                            cssClass="regular tertiary"
                            style={{ boxShadow: 'none' }}
                            label={i18n.t('h_surveys_viewall')}
                        />
                    </div>
                    {this.homeStore.loadSpinner ? this.spinner() : this.renderDataTable(selectedTab)}
                </Panel>
            </Fragment>
        )
    }

    renderButtons = () => {
        const { store } = this.props
        const { activeTabKey } = this.state

        const possibleButtons = [
            {
                name: 'Create a survey',
                allowedRoles: ['100', '110', '120', '130', '140', '160'],
                element: () => (
                    <Button
                        cssClass="button primary large"
                        icon="fa-light fa-plus"
                        label={i18n.t('home.button.addSurvey')}
                        onClick={() => this.homeStore.toggleIndustryChoose('survey')}
                    />
                ),
                hide: (activeTabKey === 'EM'),
            },
            {
                name: 'createRapidSurvey',
                allowedRoles: ['100', '110', '120', '130', '140', '160'],
                element: () => (
                    <Button
                        cssClass="button primary large rapidSurvey"
                        onClick={this.homeStore.openCreateRapid}
                    >
                        <div>
                            <img src={icon} alt={i18n.t('home.button.addRapidSurvey')} />
                            <i className="fa fa-light fa-clipboard-list" />
                        </div>
                        <Typography type="b">
                            {i18n.t('home.button.addRapidSurvey')}
                        </Typography>
                    </Button>
                ),
                hide: (!store.userData.flags.isRapidSurveysEnabled),
            },
            {
                name: 'createMaxbiEntry',
                allowedRoles: ['100', '110', '120', '130', '140', '160'],
                element: () => (
                    <Button
                        cssClass="button primary large"
                        icon="fa-light fa-circle-plus"
                        label={i18n.t('home.buttons.exhibitMeasurement')}
                        onClick={this.homeStore.openCreateMaxbi}
                    />
                ),
                hide: (activeTabKey !== 'EM'),
            },
        ]

        const allowedButtons = possibleButtons.map((button) => {
            if (this.permissionCheck(button.allowedRoles) && !button.hide) return button.element()
        })

        if (allowedButtons.length > 0) return (<div className="mid">{allowedButtons}</div>)

        return null
    }

    render() {
        const { store } = this.props
        const { activeTabKey } = this.state
        const showMaxbiNonMaxbi = this.maxbiStatus.maxbi && this.maxbiStatus.nonMaxbi
        const { userData } = store
        const firstName = R.pathOr('', ['firstName'], userData)

        return (
            <div id="home">
                {showMaxbiNonMaxbi && (
                    <div id="top-bar">
                        <div className="notification">
                            {/* <i className="fa-regular fa-circle-exclamation" />
                            <span>Notification</span>
                            <p>&nbsp;- Your survey has not been found</p> */}
                        </div>
                        <div className="switch-button">
                            <ul className="category-filter-menu">
                                {this.surveyTabs.map((tab) => (
                                    <li key={tab.key}>
                                        <Button
                                            onClick={() => {
                                                this.setState({ activeTabKey: tab.key })
                                            }}
                                            type="button"
                                            cssClass={`${(activeTabKey === tab.key) ? 'active' : ''}`}
                                        >
                                            <i className="fa-regular fa-square-poll-vertical" />
                                            {tab.value}
                                        </Button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
                <div id="container">
                    <div className="left-container">
                        <div className="up">
                            <h2>{`${i18n.t('home.welcome')} ${firstName}`}</h2>
                            <p dangerouslySetInnerHTML={{ __html: activeTabKey === 'EM' ? i18n.t('home.welcomeText.maxbi') : i18n.t('home.welcomeText.nonMaxbi') }} />
                        </div>
                        {this.renderButtons()}
                        <div className="low">
                            <Anchor cssClass="external-anchor" href="http://kb.explori.com/knowledge" target="_blank" isExternal>
                                <i className="fa-light fa-book-open-cover" />
                                {i18n.t('home.bottombuttons.knowledgeBase')}
                            </Anchor>
                            <hr />
                            <Anchor cssClass="external-anchor" href="mailto:support@explori.com" target="_blank" isExternal>
                                <i className="fa-light fa-headset" />
                                {i18n.t('dash_leftinfo4_title')}
                            </Anchor>
                        </div>
                    </div>
                    <div className="right-container">
                        {this.renderPanels()}
                    </div>
                </div>
                <ChooseIndustryModal
                    show={this.homeStore.industryChooseOpen}
                    onSelect={this.homeStore.openCreateItem}
                    onClose={this.homeStore.toggleIndustryChoose}
                    industries={this.homeStore.industries}
                />
            </div>
        )
    }
}

export default Home
